import { LayerData } from "./layerData.model";
import type Konva from "konva"

type ShapeData = | { shape: "rectangle"; shape_params: Konva.RectConfig }
    | { shape: "ellipse"; shape_params: Konva.EllipseConfig }
    | { shape: "line"; shape_params: Konva.LineConfig }
    | { shape: "path"; shape_params: Konva.PathConfig }

export class ColorLayerData extends LayerData {
    color: [number, number, number];
    shape_data: ShapeData

    constructor(data?: Partial<ColorLayerData>) {
        super(data);
        this.color = (data?.color as [number, number, number]) ?? [0, 0, 0];
        this.shape_data = data?.shape_data ?? { shape: "rectangle", shape_params: {} }
        this.type = "color";
    }
}
